import { authClient } from "@/shared/lib/axios";
import {
	type CreateWorkflowRequest,
	CreateWorkflowRequestSchema,
	type DeleteWorkflowResponse,
	DeleteWorkflowResponseSchema,
	type GetWorkflowsResponse,
	GetWorkflowsResponseSchema,
	type UpdateWorkflowRequest,
	UpdateWorkflowRequestSchema,
	type Workflow,
	WorkflowSchema,
} from "./workflow.types";

const WORKFLOW_ENDPOINT = "/workflows";

type PaginationParams = {
	page?: number;
	limit?: number;
};

export const workflowApi = {
	list: async (params: PaginationParams = {}): Promise<GetWorkflowsResponse> => {
		const { data } = await authClient.get(WORKFLOW_ENDPOINT, { params });
		return GetWorkflowsResponseSchema.parse(data);
	},

	get: async (id: string): Promise<Workflow> => {
		const { data } = await authClient.get(`${WORKFLOW_ENDPOINT}/${id}`);
		if (data.graph !== undefined && data.definition === undefined) {
			data.definition = data.graph;
		}
		return WorkflowSchema.parse(data);
	},

	create: async (request: CreateWorkflowRequest): Promise<Workflow> => {
		const payload = CreateWorkflowRequestSchema.parse(request);
		const { data } = await authClient.post(WORKFLOW_ENDPOINT, payload);
		return WorkflowSchema.parse(data);
	},

	update: async (id: string, request: UpdateWorkflowRequest): Promise<Workflow> => {
		const payload = UpdateWorkflowRequestSchema.parse(request);
		const { data } = await authClient.patch(`${WORKFLOW_ENDPOINT}/${id}`, payload);
		if (data.graph !== undefined && data.definition === undefined) {
			data.definition = data.graph;
		}
		return WorkflowSchema.parse(data);
	},

	remove: async (id: string): Promise<DeleteWorkflowResponse> => {
		const { data } = await authClient.delete(`${WORKFLOW_ENDPOINT}/${id}`);
		return DeleteWorkflowResponseSchema.parse(data);
	},
};
